import { Components } from '@mui/material/styles/components';
import { ControllerDataGridColor } from '../../palette';
import { ControllerFont } from '../../fonts';
import theme from '../../provider/controllerBaseTheme';

export const DataGridComponent: Components = {
  MuiDataGrid: {
    styleOverrides: {
      cell: {
        padding: theme.spacing(0, 1),
        borderBottom: `1px solid ${ControllerDataGridColor.Border}`,
        '&:focus-within': {
          outline: 'none',
        },
        '&:hover.MuiDataGrid-cell--editable': {
          backgroundColor: 'white',
        },
      },
      cellCheckbox: {
        textOverflow: 'unset',
      },
      columnHeader: {
        padding: 0,
        paddingRight: theme.spacing(0.5),
        '&:focus-within': {
          outline: 'none',
        },
      },
      columnHeaderTitle: {
        ...ControllerFont.Heading300B,
      },
      columnHeaderTitleContainer: {
        padding: theme.spacing(0, 1),
      },
      columnSeparator: {},
      row: {
        '&:last-child': {
          '& .MuiDataGrid-cell': {
            borderBottom: 'none',
          },
        },
        '&:hover .showCellEditableIcon': {
          visibility: 'visible',
        },
      },
      panelWrapper: {
        backgroundColor: theme.palette.background.paper,
      },
      toolbarContainer: {
        marginTop: 16,
        padding: theme.spacing(1, 0),
      },
      rowCount: {
        margin: 0,
      },
      selectedRowCount: {
        margin: 0,
      },
      root: {
        borderColor: String(ControllerDataGridColor.Border),
        borderRadius: theme.spacing(0.25),
        padding: theme.spacing(0, 2),
        '& .MuiDataGrid-columnsContainer': {
          borderBottom: `1px solid ${ControllerDataGridColor.Border}`,

          '& .MuiDataGrid-columnHeaderWrapper': {
            maxHeight: 'inherit',
            minHeight: 'inherit',
          },
        },
        '& .MuiDataGrid-columnHeader': {
          '& .MuiDataGrid-columnHeaderTitleContainer': {
            '& .MuiDataGrid-iconButtonContainer': {
              '& .MuiIconButton-root': {
                paddingLeft: theme.spacing(0.25),
                paddingRight: 0,
                width: 'auto',
                '&:hover': {
                  // don't show hover background for sort icon
                  backgroundColor: 'transparent',
                },
                '& .MuiTouchRipple-root': {
                  // don't show ripple effect when sort icon is pressed
                  display: 'none',
                },
              },
            },
          },
        },
      },
    },
  },
};
